export default {
  programming: {
    languages: {
      good: ['TypeScript', 'Go', 'C / C++'],
      ok: ['Rust', 'Python'],
    },
    space: [4],
    list: [
      'Praktyczna znajomość języków <b>Go</b>, <b>Rust</b> i <b>C/C++</b> w programowaniu ogólnym, aplikacyjnym, obiektowym, sieciowym i <b>embedded</b>.',
      'Integracja <b>AI</b> z innymi warstwami aplikacji. Praktyczna znajomość działów <b>uczenia maszynowego</b> i <b>deep learningu</b>.',
      'Programowanie aplikacji desktopowych i internetowych przy użyciu technologii <b>Vue</b> oraz języka <b>TypeScript</b>.',
      'Zarządzanie bazami danych - doświadczenie w <b>SQLite</b>, <b>MongoDB</b> oraz <b>MySQL</b>. Podstawy DevOps, w tym <b>Google Cloud</b>.',
      'Umiejętność <b>modelowania procesów fizycznych</b> i przeprowadzania <b>symulacji komputerowych</b>, w tym z użyciem <b>ML</b>.',
      'Znajomość metod komputerowej inżynierii materiałowej takich jak <b>Monte Carlo</b>, <b>dynamika molekularna</b> czy <b>DFT</b>.',
    ],
  },
  technical: {
    space: [3, 6],
    list: [
      'Wiedza o <b>systemach operacyjnych</b> i <b>architekturze komputerów</b>. Praca w systemach <b>Linux / UNIX</b>, w tym znajomość <b>shella</b>.',
      'Podstawowa znajomość <b>teleinformatyki</b>, w zagadnieniach takich jak sieci komputerowe oraz bezpieczeństwo danych.',
      'Praktyczna wiedza z zakresu <b>telekomunikacji</b>. Konfigurowanie instalacji i tworzenie systemów internetowych.',
      'Obsługa sprzętu komputerowego i pomiarowego. <b>Komputeryzacja pomiarów</b> w języku <b>LabVIEW</b>.',
      'Diagnostyka i naprawa <b>urządzeń elektronicznych</b>. Umiejętność czytania <b>schematów elektronicznych</b>.',
      'Podstawy obsługi i programowania mikrokontrolerów <b>AVR</b> i systemów wbudowanych, w szczególności <b>Arduino</b>.',
      'Umiejętność wykonywania i czytania <b>rysunków technicznych</b> oraz tworzenie schematów 2D i 3D w programie <b>NX</b>.',
      'Doświadczenie w zaawansowanych metodach badania materiałów takich jak m.in.: <b>XRD, DSC, DTA / TGA, TMA, XAS</b>, a także <b>spektroskopii</b>: absorpcyjnej, luminescencyjnej, impedancyjnej czy podczerwonej.',
    ],
  },
  science: {
    space: [5],
    list: [
      'Kompleksowa znajomość procesów i technologii stosowanych w <b>fizyce i chemii zaawansowanych materiałów</b>.',
      'Doświadczenie w <b>fizyce procesów jonowych</b>, w szczególności technologii <b>przetwarzania i magazynowania energii</b>.',
      'Wiedza z zakresu nowoczesnych zastosowań <b>fizyki struktur półprzewodnikowych</b> i <b>elektroniki ciała stałego</b>.',
      'Praktyczna znajomość teorii i procesów technologicznych w wytwarzaniu <b>nanostruktur</b> i <b>układów niskowymiarowych</b>.',
      'Praktyczna wiedza i rozwiązywanie problemów z zakresu <b>fizyki laserów</b>, <b>optoelektroniki i fotoniki</b> oraz zastosowań <b>fizyki jądrowej</b>.',
      'Znajomość elementów zaawansowanej <b>matematyki wyższej</b> w <b>zastosowaniach inżynierskich i programistycznych</b>.',
      'Podstawowa znajomość <b>statystyki i analizy danych</b> w <b>ROOT</b> i <b>Python</b>. Praca w bibliotekach <b>NumPy</b>, <b>Pandas</b> i <b>Matplotlib</b>.',
      'Podstawowa umiejętność przeprowadzania <b>obliczeń numerycznych</b> oraz symbolicznych w <b>Mathematica</b> i <b>Python</b>.',
    ],
  },
  soft: {
    list: [
      'Łatwość w <b>przyswajaniu wiedzy</b>. Błyskawiczne <b>uczenie się</b>, <b>elastyczność</b> i <b>adaptacja</b> do zmian.',
      'Umiejętność <b>zarządzania projektami</b> i <b>pracą zespołową</b>. Doświadczenie w roli lidera i członka zespołu.',
      'Dobre <b>umiejętności komunikacyjne</b> i organizacyjne. <b>Otwartość w kontaktach</b> z ludźmi.',
      'Doświadczenie w specjalistycznej komunikacji w języku <b>angielskim</b> potwierdzona udziałem w konferencjach naukowych.',
      'Umiejętność <b>logicznego, kreatywnego i krytycznego myślenia</b>.',
    ],
  },
}
